import PaymentMethodView from './PaymentMethodView'

export default PaymentMethodView
